module.exports = __webpack_public_path__ + "static/media/lemons-right.64a2f332.png";